import React from "react";

import {
  Box,
  Flex,
  Text,
  Input,
  Button,
  Checkbox,
  Link
} from "@chakra-ui/react";

export default function ForgotPage() {
  return (
    <Flex flexDirection="Column" align="center" height="600px">
      <Text
        fontFamily="sans-serif"
        fontWeight="bold"
        fontsize="18"
        marginTop={115}>
        Password Recovery
      </Text>
      <Text marginTop="2">
        Enter your email and we’ll send you further instructions
      </Text>
      <Input
        placeholder="Enter your email"
        type="email"
        width="310px"
        focusBorderColor="blue.500"
        marginTop={4}
      />
      <Button onClick={null} colorScheme="blue" marginTop="4">
        Send
      </Button>
    </Flex>
  );
}
